import { render } from "./AwardDetailNov2023Page.vue?vue&type=template&id=bdcd8c7c"
import script from "./AwardDetailNov2023Page.vue?vue&type=script&lang=js"
export * from "./AwardDetailNov2023Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__